import React, { useContext, useEffect, useState } from "react";

import axios from "axios";
import { Card, Spinner } from "react-bootstrap";
import PsContext from "../../context";
import { getLs, momentDate, setLs, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { IconButton, ListItem, ListItemText } from "@mui/material";
import { getDayValueByDate } from "../../models/academicYears";

const TodayDayOrder = (props) => {
  const context = useContext(PsContext);
  const [dataList, setDataList] = useState(
    getLs("stu_mob_day_order_value") || null
  );
  const [loader, setLoader] = useState(false);
  const today = momentDate(new Date(), "YYYY-MM-DD");
  const [holiday, setHoliday] = useState([]);
  useEffect(() => {
    let day_order_date = getLs("stu_mob_day_order_date");
    //if (today != day_order_date) loadData();
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    setDataList(null);
    const PARAMS = "college_uuid=" + context.user.college_uuid;
    getDayValueByDate(PARAMS).then((res) => {
      console.log(res);
      if (res.status == "1") {
        res && setDataList(res.data);
        setLoader(false);
      } else {
        setHoliday(res.data);
      }
    });
  };

  return (
    <>
      {holiday && holiday.length > 0 ? (
        <div className="text-center py-3 ">
          <span
            className="bg-theme-outlined fw-bold py-1 px-2 bg-color"
            style={{ fontSize: "14px" }}
          >
            {holiday[0].holiday_name}
          </span>
        </div>
      ) : (
        <ListItem
          secondaryAction={
            <span
              edge="end"
              className="fw-bold bg-theme py-1 px-2 text-white"
              style={{ fontSize: "14px" }}
            >
              {loader && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="fw-bolder text-black"
                />
              )}
              {dataList}
            </span>
          }
        >
          <ListItemText primary="Today Day order" />
        </ListItem>
      )}
    </>
  );
};
export default TodayDayOrder;
